module.exports = __webpack_public_path__ + "static/media/datasheet_listData_row12_appleQRcode.e91f7a81.png";